var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5611_80691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 0.0419922C9.3535 0.0449033 6.81663 1.09727 4.94549 2.96822C3.07435 4.83918 2.02173 7.37593 2.01855 10.022C2.01855 12.592 4.00855 16.614 7.93355 21.976C8.40081 22.6161 9.01261 23.1369 9.71916 23.4959C10.4257 23.8549 11.207 24.042 11.9996 24.042C12.7921 24.042 13.5734 23.8549 14.28 23.4959C14.9865 23.1369 15.5983 22.6161 16.0656 21.976C19.9906 16.614 21.9806 12.592 21.9806 10.022C21.9774 7.37593 20.9248 4.83918 19.0536 2.96822C17.1825 1.09727 14.6456 0.0449033 11.9996 0.0419922ZM11.9996 14C11.2084 14 10.4351 13.7654 9.77727 13.3259C9.11948 12.8863 8.60679 12.2616 8.30404 11.5307C8.00129 10.7998 7.92207 9.99556 8.07641 9.21963C8.23075 8.44371 8.61172 7.73098 9.17113 7.17157C9.73054 6.61216 10.4433 6.23119 11.2192 6.07685C11.9951 5.92251 12.7994 6.00172 13.5303 6.30448C14.2612 6.60723 14.8859 7.11992 15.3254 7.77771C15.765 8.43551 15.9996 9.20887 15.9996 9.99999C15.9996 11.0609 15.5781 12.0783 14.828 12.8284C14.0778 13.5786 13.0604 14 11.9996 14Z",
    fill: "#724AE8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5611_80691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.828236f3ce2e34d3ead0feb7f2b52a60.svg";
export { ForwardRef as ReactComponent };